define('controllers/registrationprocess',['require'],function(require) {
    return function () {
        var stepButtons = $("button[data-stepurl]"),
            step = parseInt(window.ServerData.feData.userNextStep),
            doneSteps = $("#steps > div:lt(" + (step - 1) + ")"),
            currentStepButton = $("#steps .stepBtn:eq(" + (step - 1) + ")");

        doneSteps.addClass("done");
        currentStepButton.prop('disabled', false);

        stepButtons.on("click", function () {
            window.location = $(this).attr("data-stepurl");
        });

        //alert if we can't set cookies
        if (!CookieUtil.supportingCookies()) {
            $("#cookiesDisabled").show();
        }
    };
});

